import { render } from "./HelloWorld.vue?vue&type=template&id=5acfb8ef&scoped=true"
import script from "./HelloWorld.vue?vue&type=script&lang=js"
export * from "./HelloWorld.vue?vue&type=script&lang=js"

import "./HelloWorld.vue?vue&type=style&index=0&id=5acfb8ef&scoped=true&lang=css"

import exportComponent from "/Users/jason/code/feproj/seedling/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5acfb8ef"]])

export default __exports__